document.addEventListener('DOMContentLoaded',()=>{
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-ff-hero]').forEach(hero=>{
    if (reduce) return;
    let frame = 0;
    const setPointer=(x,y)=>{
      cancelAnimationFrame(frame);
      frame=requestAnimationFrame(()=>{
        hero.style.setProperty('--mx', `${x}px`);
        hero.style.setProperty('--my', `${y}px`);
      });
    };
    hero.addEventListener('pointermove',(e)=>{
      const r=hero.getBoundingClientRect();
      setPointer((((e.clientX-r.left)/r.width)-.5)*18,(((e.clientY-r.top)/r.height)-.5)*18);
    },{passive:true});
    hero.addEventListener('pointerleave',()=>setPointer(0,0),{passive:true});
  });
  const hero=document.querySelector('[data-ff-hero]');
  if(hero && !reduce){
    let ticking=false;
    const onScroll=()=>{
      if(ticking) return;
      ticking=true;
      requestAnimationFrame(()=>{
        const r=hero.getBoundingClientRect();
        const progress=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height)));
        hero.style.setProperty('--ff-hero-y', `${progress*26}px`);
        ticking=false;
      });
    };
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  }
  if('IntersectionObserver' in window && !reduce){
    const obs=new IntersectionObserver((entries)=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-ff-visible');obs.unobserve(entry.target)}}),{threshold:.12,rootMargin:'0px 0px -4%'});
    document.querySelectorAll('[data-ff-reveal]').forEach(el=>obs.observe(el));
  }else{
    document.querySelectorAll('[data-ff-reveal]').forEach(el=>el.classList.add('is-ff-visible'));
  }
});